import { render } from "./BarcodeScan.vue?vue&type=template&id=fa3e5b1c"
import script from "./BarcodeScan.vue?vue&type=script&lang=js"
export * from "./BarcodeScan.vue?vue&type=script&lang=js"
script.render = render

export default script